export default __webpack_public_path__ + "static/media/Delivered.1457afea.svg";